import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { dayJsFromString } from '@/utilities/datetime';

const EXTEND_MONTH_ARRAY = [1, 3, 6, 12];

const TalonOneDatePicker = ({
  startingDate,
  selectedDate,
  setSelectedDate,
  label,
  required,
}: {
  startingDate: string;
  selectedDate: string | null;
  setSelectedDate: (v: string) => void;
  label: string;
  required?: boolean;
}) => {
  const { t } = useTranslation();

  const expiryDate = startingDate;
  const expiryDates = startingDate
    ? EXTEND_MONTH_ARRAY.map((item) => {
        const expiryTime = dayJsFromString(expiryDate, 'DD-MM-YYYY HH:mm:ss') || dayjs();
        const newDate = expiryTime.add(item, 'month');

        return {
          date: newDate.toISOString(),
          text: `${newDate.format('DD/MM/YYYY')} - ${t('common.month_range', {
            count: item,
          })}`,
        };
      })
    : [];

  useEffect(() => {
    setSelectedDate(expiryDates[expiryDates.length - 1]?.date);
  }, []);

  const handleChange = (e: SelectChangeEvent) => {
    setSelectedDate(e.target.value);
  };

  return (
    <FormControl
      required={required}
      fullWidth={true}
    >
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        label={label}
        value={selectedDate || expiryDates[expiryDates.length - 1]?.date}
        onChange={handleChange}
        displayEmpty
      >
        {expiryDates.map((item, index) => (
          <MenuItem
            value={item.date}
            key={index}
          >
            {item.text}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TalonOneDatePicker;
